// extracted by mini-css-extract-plugin
export var fullGrid = "_33-3";
export var pdpPreviewContainer = "_33-1";
export var previewContainer = "_33-0";
export var togglePreviewContainer = "_33-2";